import { SET_ACTIVE_FILES, SET_ARCHIVES, SET_AUDIT_RESULTS, SET_MAPPED_RULES, SET_REMINDER, SET_REMINDER_ACTION,SET_REMINDER_ARCHIVE, SET_REMINDER_ACTION_ARCHIVE } from "../actions/actionTypes";

export const setArchives = (payload) => {

	return {
		type: SET_ARCHIVES,
		payload,
	};
};

export const setAuditResults = (payload) => {

	return {
		type: SET_AUDIT_RESULTS,
		payload,
	};
};

export const setReminder = (payload) => {

	return {
		type: SET_REMINDER,
		payload,
	};
};

export const setReminderActionPerformed = (payload) => {

	return {
		type: SET_REMINDER_ACTION,
		payload,
	};
};

export const setReminderArchive = (payload) => {

	return {
		type: SET_REMINDER_ARCHIVE,
		payload,
	};
};

export const setReminderArchiveActionPerformed = (payload) => {

	return {
		type: SET_REMINDER_ACTION_ARCHIVE,
		payload,
	};
};

export const setMappedRules = (payload) => {

	return {
		type: SET_MAPPED_RULES,
		payload,
	};
};

export const setActiveFiles = (payload) => {

	return {
		type: SET_ACTIVE_FILES,
		payload,
	};
};